import React from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import SportsBaseballIcon from "@mui/icons-material/SportsBaseball";
import TimelineIcon from "@mui/icons-material/Timeline";
import GroupsIcon from "@mui/icons-material/Groups";
import PercentIcon from "@mui/icons-material/Percent";
import {
  RECOMMENDED_FILTERS,
  formatQueryStatValue,
  getRecommendedThreshold,
  isRecommendedFilterActive,
} from "../../utils/queryBuilder";
import { BRAND_COLORS, brandRgba } from "../../utils/brandAssets";

const FILTER_ICONS = {
  homeruns: SportsBaseballIcon,
  hits: TimelineIcon,
  runBattedIn: GroupsIcon,
  battingAverage: PercentIcon,
};

const QueryRecommendedFilters = ({ queryParams, onToggle, filters }) => {
  const activeFilters = filters || RECOMMENDED_FILTERS;
  return (
  <Box
    sx={{
      display: "grid",
      gridTemplateColumns: { xs: "1fr 1fr", md: "repeat(4, 1fr)" },
      gap: 1.25,
    }}
  >
    {activeFilters.map((filter) => {
      const selected = isRecommendedFilterActive(queryParams, filter);
      const Icon = FILTER_ICONS[filter.id] || SportsBaseballIcon;
      const threshold = getRecommendedThreshold(filter, queryParams.queryType);

      return (
        <Paper
          key={filter.id}
          component="button"
          type="button"
          onClick={() => onToggle(filter.id)}
          sx={{
            p: 1.5,
            width: "100%",
            textAlign: "left",
            cursor: "pointer",
            display: "block",
            font: "inherit",
            color: "inherit",
            border: "1px solid",
            borderColor: selected ? "primary.main" : "divider",
            bgcolor: selected ? "action.selected" : "background.paper",
            transition: "transform 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
            "&:hover": {
              transform: "translateY(-2px)",
              borderColor: "primary.main",
              boxShadow: `0 8px 24px ${brandRgba(BRAND_COLORS.cyan, 0.12)}`,
            },
          }}
        >
          <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 0.75 }}>
            <Icon
              fontSize="small"
              sx={{ color: selected ? "primary.main" : "text.secondary" }}
            />
            <Typography variant="subtitle2" fontWeight={800}>
              {filter.abbrev}
            </Typography>
          </Stack>
          <Typography variant="caption" color="text.secondary" display="block">
            {filter.label} {filter.operator} {formatQueryStatValue(filter.stat, threshold)}
          </Typography>
        </Paper>
      );
    })}
  </Box>
  );
};

export default QueryRecommendedFilters;
